<template>
  <validation-observer
      ref="form"
      #default="{ invalid }"
      tag="form"
      class="repeater__form"
      style="overflow: visible"
  >
    <b-modal
        v-model="show"
        content-class="package-modal rounded-8"
        dialog-class="wameed-modal-md"
        no-fade
        :key="key"
    >
      <template slot="modal-header-close">
        <close-icon/>
      </template>
      <template slot="modal-title">
        <div class="d-block text-center">
          <h3 class="text-reg-18">
            {{ modalData != null ? $t('order_types.update_btn') : $t('order_types.new_btn') }}
          </h3>
        </div>
      </template>


      <b-row>
        <b-col md="6" v-for="locale in locales" :key="locale">
          <text-input
              v-model="form['name_'+locale]"
              :label="$t('order_types.form.name_'+locale)"
              :placeholder="$t('form.text.placeholder')"
              name="package-ad"
              rules="required"
          />
        </b-col>

        <b-col md="12">
          <wameed-dropdown
              v-model="form.service_type"
              :label="$t('order_types.form.service_type')"
              :placeholder="$t('form.text.placeholder')"
              variant="disable"
              :items="getServices"
              title="name"
              class="wameed_dropdown"
              rules="required"
              @input="updateModal"
              :no_options="$t('common.no_options')"

          />
        </b-col>

      </b-row>

      <template slot="modal-footer">
        <wameed-btn
            classes="  text-med-14 text-white mx-0 rounded-8"
            :title="modalData!=null ?$t('btn.update'):$t('btn.add')"
            :disabled="invalid"
            type="submit"
            variant="main"
            @onClick="submitOrder()"
        />
        <wameed-btn
            classes="  text-med-14 text-font-secondary mx-0 rounded-8 "
            :title="$t('btn.cancel')"
            type="button"
            variant="gray"
            @onClick="closeModal()"
        />
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import {WameedBtn, WameedTextInput as TextInput} from 'wameed-ui/dist/wameed-ui.esm';
import {mapActions, mapGetters} from 'vuex';
import {availableLocales} from '@/enums/locales.enum'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    WameedBtn,
    TextInput,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    modalData: {
      type: Object,
      default: null,
    },

  },

  data() {
    return {
      key:1,
      locales: availableLocales,
      form: {
        service_type: ''
      },
      showSuccessModal: false,
    };
  },
  computed: {
    ...mapGetters({
      getServices: 'admin/settings/order_types/getServices',
    }),
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
  watch: {
    modalData(newVal) {
      if (newVal != null) {
        this.form = newVal;
      } else {
        this.form.name = '';
      }
    },
  },
  created() {
    if (this.modalData != null) {
      this.form = this.modalData
    }
  },
  methods: {
    ...mapActions({
      create: "admin/settings/order_types/create",
      update: "admin/settings/order_types/update",
    }),
    uploadProfileImage(value) {
      this.form.icon = value;
    },

    updateModal(v) {
      this.key += 1;
    },

    submitOrder() {

      this.form.service_type_id = this.form.service_type.id;
      if (this.modalData == null) {
        this.create(this.form).then(() => {
          this.$emit('onComplete', true);
          this.closeModal();
          this.$store.commit('loadingFinish', null, {root: true});
        });
      } else {
        this.update({
          ...this.form,
          id: this.modalData.id,

        }).then(() => {
          this.$emit('onComplete', true);
          this.closeModal();
          this.$store.commit('loadingFinish', null, {root: true});
        });
      }
    },


    closeModal() {
      this.form = {
        icon: '',
      };
      this.show = false;
    },
  },
};
</script>
